module.exports = __webpack_public_path__ + "img/activity_rule.1636353669329.png";